<template>
    <div class="agreement-webview">
        <div :style="{ with: '100%', height: statusBarHeight + 'px' }"></div>
        <!-- 导航栏 -->
        <van-sticky>
            <van-nav-bar @click-left="handelBack" :border="false">
                <template #title>
                    <span>{{ $t(title) }}</span>
                </template>
                <template #left>
                    <img class="back-icon" src="@/assets/icon_back.png" alt="" />
                </template>
            </van-nav-bar>
        </van-sticky>
        <div class="agreement-webview-content">
            <iframe :src="url" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
import { appFunc_changeBar } from '@/utils/bridge'

export default {
    data() {
        return {
            title: 'bbbbb',
            url: '',
            statusBarHeight: 0
        }
    },
    created() {
        const { title, url, statusBarHeight } = this.$route.query
        this.statusBarHeight = +statusBarHeight
        this.title = title
        this.url = url
        if(this.statusBarHeight) {
            appFunc_changeBar({ statusBarModel: true, navBarBackground: '#FFFFFF' })
        }
    },
    methods: {
        handelBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.agreement-webview {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .agreement-webview-content {
        flex: 1;
        overflow: hidden;

        iframe {
            width: 100%;
            height: 100%;

        }
    }
}

.nav-bar {
    height: 44px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 30px;
        height: 30px;
        position: absolute;
        left: 5px;
    }

    .nav-title {
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        -webkit-text-stroke: .3px #181818;
        color: #181818;
    }
}

.back-icon {
    width: 30px;
    height: 30px;
}

::v-deep .van-nav-bar__left {
    padding-left: 9px;
}
</style>